import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ImageModalStore from './store';
import Link from '../../components/link';

import ModalContainer from '../../components/modal-container';
import BaseSwiper from '../../components/swiper/base-swiper';
import ImageWithLoading from '../../components/image-with-loading';
import cx from 'classnames';

const styles = require('./index.less');

const ImageModal = ({ store, onClose }) => {
  store.use();

  return (
    <ModalContainer modalState={store.modalState}>
      <div className={styles.imageModalRoot}>
        {store.imagesList?.length > 0 && (
          <div className={styles.imageModalContent}>
            <Link className={cx(styles.btnPrev, store.isDisablePrev && styles.btnDisable)} onClick={() => store.onPrevClick()} />
            <div className={styles.swiperBox}>
              <BaseSwiper store={store.imageModalSwiperStore}>
                {store.imagesList.map((item, index) => {
                  return (
                    <div key={index} className={styles.listItem}>
                      <ImageWithLoading className={styles.listItem} imgUrl={item} />
                    </div>
                  );
                })}
              </BaseSwiper>
            </div>
            <Link className={cx(styles.btnNext, store.isDisableNext && styles.btnDisable)} onClick={() => store.onNextClick()} />
          </div>
        )}
        <Link
          className={styles.btnClose}
          onClick={() => {
            store.onModalStateChange(false);
            onClose();
          }}
        />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(ImageModal, ImageModalStore);
